var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import useKeyDownListener from 'hooks/useKeyDownListener';
import FilePlusSvg from 'images/v5/icons/file-plus-01.svg';
import Breadcrumbs from 'layout/atoms/Breadcrumbs/Breadcrumbs';
import Button from 'layout/atoms/Button/Button';
import Modal from 'layout/atoms/Modal/Modal';
import { closeModal } from 'store/layoutSlice';
import { addAndAssignSpecificationComponents, clearComponentsToAssign, selectSpecificationComponentsCategory, selectSpecificationComponentsComponentName, selectSpecificationComponentsModalView, selectSpecificationComponentsToAssign, setCategory, setComponentRefetchFlag, setModalView, } from 'store/specificationComponentsSlice';
import { selectSpecificationId } from 'store/specificationDetailsSlice';
import ModalContent from './ModalContent';
function ComponentsSelector() {
    const { t, i18n } = useTranslation(['specification', 'common']);
    const dispatch = useDispatch();
    const [addingComponents, setAddingComponents] = useState(false);
    const modalView = useSelector(selectSpecificationComponentsModalView);
    const category = useSelector(selectSpecificationComponentsCategory);
    const componentName = useSelector(selectSpecificationComponentsComponentName);
    const componentsToAssign = useSelector(selectSpecificationComponentsToAssign);
    const readyToSubmit = useSelector(selectSpecificationComponentsToAssign).length > 0;
    const modelSpecificationId = useSelector(selectSpecificationId);
    useKeyDownListener([
        { code: 'Enter', callback: () => dispatch(closeModal({ name: 'componentsSelector' })) },
        { code: 'Escape', callback: () => dispatch(closeModal({ name: 'componentsSelector' })) },
    ]);
    useEffect(() => {
        dispatch(setCategory(null));
        dispatch(setModalView('categories'));
    }, [dispatch]);
    const handleClose = () => {
        dispatch(clearComponentsToAssign());
        dispatch(setModalView('categories'));
        dispatch(setCategory(null));
    };
    const handleCancel = () => {
        dispatch(clearComponentsToAssign());
        dispatch(setModalView('categories'));
        dispatch(setCategory(null));
        dispatch(closeModal({ name: 'componentsSelector' }));
    };
    const handleSubmit = () => __awaiter(this, void 0, void 0, function* () {
        setAddingComponents(true);
        try {
            yield dispatch(addAndAssignSpecificationComponents({
                components: componentsToAssign,
                modelSpecificationId,
                language: i18n.language,
            })).unwrap();
            setAddingComponents(false);
            dispatch(clearComponentsToAssign());
            dispatch(setCategory(null));
            dispatch(setModalView('categories'));
            dispatch(setComponentRefetchFlag(true));
            dispatch(closeModal({ name: 'componentsSelector' }));
        }
        catch (error) {
            setAddingComponents(false);
            // eslint-disable-next-line no-console
            console.error('Adding specifications component', error);
        }
    });
    return (React.createElement(Modal, { name: "componentsSelector", size: "fullScreen", noPadding: true, onClose: handleClose, header: React.createElement(Breadcrumbs, { items: [
                {
                    id: 'components',
                    name: t('components'),
                    onClick: () => dispatch(setModalView('components')),
                },
                {
                    id: 'category',
                    name: (category === null || category === void 0 ? void 0 : category.name) || '-',
                    onClick: () => dispatch(setModalView('components')),
                },
                ...(modalView === 'componentPreview' && componentName
                    ? [{ id: 'component', name: componentName }]
                    : []),
            ] }), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: handleCancel }, t('cancel')),
            React.createElement(Button, { color: "primary", leftIcon: React.createElement(FilePlusSvg, null), onClick: handleSubmit, disabled: !readyToSubmit, loading: addingComponents, submit: true }, readyToSubmit
                ? t('add_n_components', { count: componentsToAssign.length })
                : t('common:done'))) },
        React.createElement(ModalContent, { modalView: modalView })));
}
export default memo(ComponentsSelector);
